import SharedMessagesV2 from "@/components/shared/Messages";

export default function ConsultantMessages() {
  return <SharedMessagesV2  role="consultant" />;
}